import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ProtectedRoute } from "@/components/common";

// Eager-load only the home page (above the fold)
import HomePage from "@/pages/HomePage";

// Lazy-load all other pages to reduce initial bundle size
const BookingPage = lazy(() => import("@/pages/BookingPage"));
const ConfirmationPage = lazy(() => import("@/pages/ConfirmationPage"));
const MyBookingsPage = lazy(() => import("@/pages/MyBookingsPage"));
const PlanPaymentPage = lazy(() => import("@/pages/PlanPaymentPage"));
const PlanPaymentSuccessPage = lazy(() => import("@/pages/PlanPaymentSuccessPage"));
const MySubscriptionPage = lazy(() => import("@/pages/MySubscriptionPage"));
const AdminLogin = lazy(() => import("@/pages/admin/AdminLogin"));
const ClientLogin = lazy(() => import("@/pages/ClientLogin"));
const AdminDashboard = lazy(() => import("@/pages/admin/AdminDashboard"));
const AdminAppointments = lazy(() => import("@/pages/admin/AdminAppointments"));
const AdminBarbers = lazy(() => import("@/pages/admin/AdminBarbers"));
const AdminServices = lazy(() => import("@/pages/admin/AdminServices"));
const AdminPromotions = lazy(() => import("@/pages/admin/AdminPromotions"));
const AdminPlans = lazy(() => import("@/pages/admin/AdminPlans"));
const AdminSubscriptions = lazy(() => import("@/pages/admin/AdminSubscriptions"));
const AdminRecurrences = lazy(() => import("@/pages/admin/AdminRecurrences"));
const AdminReports = lazy(() => import("@/pages/admin/AdminReports"));
const AdminClosedDays = lazy(() => import("@/pages/admin/AdminClosedDays"));
const AdminConexoes = lazy(() => import("@/pages/admin/AdminConexoes"));
const AdminTechnical = lazy(() => import("@/pages/admin/AdminTechnical"));

function App() {
  return (
    <div className="App min-h-screen bg-[#09090b]">
      <BrowserRouter>
        <Suspense fallback={<div className="min-h-screen bg-[#09090b]" />}>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<HomePage />} />
            <Route path="/agendar" element={<BookingPage />} />
            <Route path="/confirmacao/:appointmentId" element={<ConfirmationPage />} />
            <Route path="/meus-agendamentos" element={<MyBookingsPage />} />

            {/* Auth Routes */}
            <Route path="/login" element={<AdminLogin mode="login" />} />
            <Route path="/cadastro" element={<AdminLogin mode="register" />} />
            {/* /esqueci-senha removida — sem endpoint de reset no backend */}
            <Route path="/admin/login" element={<AdminLogin mode="login" />} />

            {/* Client Auth Routes */}
            <Route path="/cliente/login" element={<ClientLogin mode="login" />} />
            <Route path="/cliente/cadastro" element={<ClientLogin mode="register" />} />

            {/* Subscription Routes */}
            <Route path="/pagamento-plano" element={<PlanPaymentPage />} />
            <Route path="/pagamento-confirmado" element={<PlanPaymentSuccessPage />} />
            <Route path="/minha-assinatura" element={<MySubscriptionPage />} />

            {/* Admin Routes */}
            <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
            <Route path="/admin/agendamentos" element={<ProtectedRoute><AdminAppointments /></ProtectedRoute>} />
            <Route path="/admin/barbeiros" element={<ProtectedRoute requireAdmin={true}><AdminBarbers /></ProtectedRoute>} />
            <Route path="/admin/servicos" element={<ProtectedRoute requireAdmin={true}><AdminServices /></ProtectedRoute>} />
            <Route path="/admin/promocoes" element={<ProtectedRoute requireAdmin={true}><AdminPromotions /></ProtectedRoute>} />
            <Route path="/admin/planos" element={<ProtectedRoute requireAdmin={true}><AdminPlans /></ProtectedRoute>} />
            <Route path="/admin/assinaturas" element={<ProtectedRoute requireAdmin={true}><AdminSubscriptions /></ProtectedRoute>} />
            <Route path="/admin/recorrencias" element={<ProtectedRoute requireAdmin={true}><AdminRecurrences /></ProtectedRoute>} />
            <Route path="/admin/relatorios" element={<ProtectedRoute><AdminReports /></ProtectedRoute>} />
            <Route path="/admin/dias-fechamento" element={<ProtectedRoute requireAdmin={true}><AdminClosedDays /></ProtectedRoute>} />
            <Route path="/admin/conexoes" element={<ProtectedRoute requireAdmin={true}><AdminConexoes /></ProtectedRoute>} />
            <Route path="/admin/technical" element={<ProtectedRoute requireAdmin={true}><AdminTechnical /></ProtectedRoute>} />
          </Routes>
        </Suspense>
      </BrowserRouter>
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: '#121212',
            border: '1px solid rgba(255, 255, 255, 0.1)',
            color: '#f8fafc',
          },
        }}
      />
    </div>
  );
}

export default App;
